import React from 'react';
import { useMedia } from 'react-use';
import DetailImage from '@/components/menus/DetailImage';
import { IMenu } from '@/@types/generated/contentful';

type ComponentProps = {
  menu: IMenu;
};

const DetailImageContainer: React.FC<ComponentProps> = ({ menu }) => {
  const isSp = useMedia('(max-width: 640px)');
  return <DetailImage menu={menu} isSp={isSp} />;
};

export default DetailImageContainer;
